import React from 'react';
import { useSpecialties } from '../../../../store/Specialties';
import { TypeCard } from '../../../../../../components/TypeCard';
import { Specialty } from '../../../../../../models/Specialist';
import { useCareTeam } from '../../../../store/CareTeam';
import { useSpecialist } from '../../../../store/Specialist';
import { useAppointments } from '../../../../store/Appointment';

type Props = {
  specialtySelected?: Specialty;
  setSpecialtySelected: (value?: Specialty) => void;
  handleAlreadyScheduled: () => void;
};

export const Specialties: React.FC<Props> = ({ specialtySelected, setSpecialtySelected, handleAlreadyScheduled }) => {
  const { specialties } = useSpecialties();
  const { careTeam } = useCareTeam();
  const { setLinkedSpecialist } = useSpecialist();
  const { appointments } = useAppointments();

  const handleSpecialty = (specialty: Specialty) => {
    const schedules = appointments.filter(schedule =>
      schedule.resource.specialties.some(sp => sp.name === specialty.name)
    );

    if (schedules.some(sh => sh.status === 'SCHEDULED' || sh.status === 'RESCHEDULED' || sh.status === 'CONFIRMED')) {
      handleAlreadyScheduled();
      setSpecialtySelected();
      setLinkedSpecialist();
    } else {
      setSpecialtySelected(specialty);

      const doctor = careTeam.find(item => item.specialities?.some(sp => sp.id === specialty.id));

      if (doctor) setLinkedSpecialist(doctor.catalogId);
      else setLinkedSpecialist();
    }
  };

  const specialtiesFiltered = React.useMemo(
    () => specialties.filter(specialty => process.env.REACT_APP_CARE_PLUS_RETURN_SPECIALTIES?.includes(specialty.id)),
    [specialties]
  );

  return (
    <>
      {specialtiesFiltered.map(item => (
        <TypeCard
          key={item.id}
          checked={item.id === specialtySelected?.id}
          onClick={() => handleSpecialty(item)}
          title={item.name}
        />
      ))}
    </>
  );
};
